import { Button, Select } from "antd";
import { QFTitle } from "@qualitas/qf-title";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { IInvestorSelectionProps } from "../IDataCollection";

const { Option } = Select;

const InvestorSelection = (props: IInvestorSelectionProps) => {
  const {
    investorsList,
    onChangeInvestor,
    advanceStep,
    selectedInvestor,
    translations,
    navigate,
	isFetchingData
  } = props;

  return (
    <div className="investor-selection-step">
      <QFTitle title={translations.updateData} size="extrabig" />
      {(investorsList.length === 0  && !isFetchingData) ? (
        <div className="no-investors-to-update">
          <label>{translations.noNeedToUpdate}</label>
          <Button
            onClick={() => navigate("/")}
            type="primary"
            size="large"
          >
            <ArrowLeftOutlined /> {translations.goToHomePage}
          </Button>
        </div>
      ) : (
        <>
          <p className="selection-step-description">
            {translations.updateDataInfo}
          </p>
          <label>{translations.selectInvestor}:</label>
          <Select
            style={{ width: "100%" }}
            placeholder={translations.selectInvestor}
            size="large"
            onChange={(e: any) => onChangeInvestor(e, "idInstitution")}
            showSearch
            disabled={investorsList.length === 0}
            filterOption={(input, option) =>
              (option?.label ?? "")
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {investorsList.map((investor: any) => (
              <Option
                key={investor.idInstitution}
                value={investor.idInstitution}
                label={investor.institutionLong}
              >
                {investor.institutionLong}
              </Option>
            ))}
          </Select>
          <Button
            onClick={() => advanceStep()}
            type="primary"
            size="large"
            disabled={!selectedInvestor}
          >
            {translations.start} <ArrowRightOutlined />
          </Button>
        </>
      )}
    </div>
  );
};

export default InvestorSelection;
